export const COOKIE_KEY_COOKIE_CONSENT = 'CookieConsent';
export const COOKIE_FIREBASE_SESSION = 'Session';
export const COOKIE_KEY_PREFERRED_COUNTRY = 'preferredCountry';
export const COOKIE_KEY_PREFERRED_LANGUAGE = 'preferredLanguage';
